import React from "react";
import { Form, Input, message } from "antd";
export default function TextInput({
  getFieldDecorator,
  label,
  name,
  disabled = false,
  required = false,
  requiredMessage = "Debe introducir un valor.",
  patternMessage = "Valor no válido.",
  callback,
  initialValue,
  pattern,
  maxLength,
  readOnly,
  placeholder,
}) {
  return (
    <Form.Item label={label}>
      {getFieldDecorator(name, {
        initialValue: initialValue,
        rules: [
          required && {
            required: true,
            message: requiredMessage,
          },
          pattern && {
            pattern: pattern,
            message: patternMessage,
          },
        ].filter(Boolean),
      })(
        <Input
          type="text"
          disabled={disabled}
          onChange={callback}
          maxLength={maxLength}
          readOnly={readOnly}
          placeholder={placeholder}
        />
      )}
    </Form.Item>
  );
}
